import moment from 'moment'

import constants from 'constants/index'

const { DATE_SCHEMA_TYPE } = constants.validations

const notInPast = {
  name: 'notInPast',
  schemaType: DATE_SCHEMA_TYPE,
  method(options = {}) {
    const message = options.message ?? 'A data não pode ser no passado'
    const inclusiveToday = options.inclusiveToday ?? true

    return this.test('notInPast', message, (value) => {
      if (!value) return true

      if (
        options.initialValue &&
        moment(value).isSame(moment(options.initialValue), 'day')
      ) {
        return true
      }

      const valueMoment = moment(value).startOf('day')
      const todayMoment = moment().startOf('day')

      return inclusiveToday
        ? valueMoment.isSameOrAfter(todayMoment)
        : valueMoment.isAfter(todayMoment)
    })
  },
}

export default notInPast
